import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectsDetailsHelpersModule } from '../helpers/helpers.module';
import { VersionsDetailsContentModule } from '@app/components/sections/versions/details/content/content.module';

import { VersionsModule } from '@core/components/versions/versions.module';
import { VersionAddModule } from '@app/components/sections/versions/add/version-add.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LayoutModule } from '@core/components/layout/layout.module';
import { FilesModule } from '@core/components/files/files.module';
import { CoreStorageModule } from '@core/components/storage/storage.module';

//components
import { ProjectDetailsVersionDetailsComponent } from './version/version.component';
import { ProjectDetailsVersionAddComponent } from './version-add/version-add.component';
import { ProjectDetailsVersionDetailsFilePreviewComponent } from './version-file-preview/version-file-preview.component';
import { ProjectDetailsVersionUploadRequestComponent } from './version-upload-request/version-upload-request.component';


@NgModule({
    imports: [
        CommonModule,
        HelpersModule,
        LayoutModule,
        FilesModule,
        CoreStorageModule,
        ProjectsDetailsHelpersModule,
        VersionsDetailsContentModule,
        VersionsModule,
        VersionAddModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectDetailsVersionDetailsComponent,
        ProjectDetailsVersionAddComponent,
        ProjectDetailsVersionDetailsFilePreviewComponent,
        ProjectDetailsVersionUploadRequestComponent
    ],
    exports: [
        ProjectDetailsVersionUploadRequestComponent
    ],

})
export class ProjectsDetailsSectionsModule{ }
